<template>
  <div
    :class="componentClass"
    style="gap: var(--spacing-xl)"
  >
    <template v-if="isReleased()">
      <template v-if="hasAccessToIconPack()">
        <site-link
          :to="$docs('/web/setup/get-started/')"
          class="button"
          style="--button-background: var(--theme-action-primary); --button-hover-background: var(--theme-action-primary-dk)"
          @click.native="$posthog.capture('pack_landing:start_using_pack_link_click', { pack: iconPack().name })"
        >
          <font-awesome-icon
            :icon="$v6.solid.faRocketLaunch"
            size="lg"
            class="margin-right-sm"
          />
          Start Using {{ iconPack().label }}
        </site-link>

        <site-link
          :to="{ name: 'latest.download' }"
          class="button"
          style="--button-background: var(--theme-action-acccent); --button-hover-background: var(--theme-action-acccent-dk)"
          @click.native="$posthog.capture('pack_landing:download_pack_link_click', { pack: iconPack().name })"
        >
          <font-awesome-icon
            :icon="$v6.solid.faArrowDownToLine"
            size="lg"
            class="margin-right-sm"
          />
          Download {{ iconPack().label }}
        </site-link>
      </template>

      <site-link
        v-else
        :to="{ name: 'plans' }"
        class="button"
        style="--button-background: var(--theme-action-primary); --button-hover-background: var(--theme-action-primary-dk)"
        @click.native="$posthog.capture('pack_landing:get_plan_link_click', { pack: iconPack().name })"
      >
        <font-awesome-icon
          :icon="$v6.solid.faRocketLaunch"
          size="lg"
          class="margin-right-sm"
        />
        Get {{ iconPack().label }} with Font Awesome {{ requiredPlanLevelForAccess() }}
      </site-link>
    </template>

    <template v-else>
      <wa-message
        v-if="hasAccessToIconPack()"
        icon-name="faClock"
        :title="`Soon ${iconPack().label} and the fa-galaxy will be yours!`"
        :content="`Your ${requiredPlanLevelForAccess()} Plan will include this Icon Pack when it's released!`"
        style="--message-border-color: var(--theme-title-tag-color); --message-with-icon-decorative-color: var(--theme-title-tag-color)"
      />

      <span
        v-else
        class="display-flex flex-items-baseline"
        style="gap: var(--spacing-md)"
      >
        <site-link
          :to="{ name: 'plans' }"
          class="button"
          style="--button-background: var(--theme-action-primary); --button-hover-background: var(--theme-action-primary-dk)"
          @click.native="$posthog.capture('pack_landing:get_plan_link_click', { pack: iconPack().name })"
        >
          <font-awesome-icon
            :icon="$v6.solid.faRocketLaunch"
            size="lg"
            class="margin-right-sm"
          />
          Get Font Awesome {{ requiredPlanLevelForAccess() }}
        </site-link>

        and get {{ iconPack().label }} when it's released!
      </span>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'PackActions',

    inject: ['hasAccessToIconPack', 'iconPack', 'isReleased', 'requiredPlanLevelForAccess'],

    props: {
      isForSmallerViewports: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      componentClass() {
        return [
          'flex-row flex-items-center',
          this.isForSmallerViewports ? 'display-flex laptop:display-none margin-top-2xl laptop:margin-top-0' : 'display-none laptop:display-flex'
        ]
      }
    }
  }
</script>
